import React from 'react';
import { Settings as SettingsIcon } from 'lucide-react';

const Settings: React.FC = () => {
  return (
    <div className="p-10 flex flex-col items-center justify-center h-full text-slate-400">
      <SettingsIcon className="h-16 w-16 mb-4 opacity-20" />
      <h2 className="text-xl font-semibold text-slate-500">Settings</h2>
      <p>System configuration and AI prompt management.</p>
    </div>
  );
};

export default Settings;
